import { SHOW_COMMEMORATE } from 'src/constants';
import styled from 'styled-components';

function WidgetBreadcrumb({ article }) {
  // console.log('article', article);
  const categoryName = article.section?.th === 'ข่าวล่าสุด' ? 'Latest News' : article.section?.th;
  const subCategoryName = article.subCategory ? article.subCategory.th : null;
  return (
    <WidgetWrapper className='breadcrumb' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
      <li>
        <a href='/'>หน้าแรก</a>
      </li>
      <li className='more-cate'>
        {' '}
        <a href={`${categoryName ? `/category/${article?.section?.en}` : ''}`}>{categoryName}</a>
      </li>
      {subCategoryName && (
        <li className='more-cate'>
          <a href={`${`/category/${article?.section?.en}/${article.subCategory.en}`}`}>{subCategoryName}</a>{' '}
        </li>
      )}
    </WidgetWrapper>
  );
}

export default WidgetBreadcrumb;

const WidgetWrapper = styled.ul`
  &.breadcrumb {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-height: 40px;
    li {
      font-size: 16pt;
      min-height: 30px;
      &.more-cate {
        a {
          color: var(--primary-color);
        }
      }
      color: var(--primary-color);
    }
    li + li {
      &:before {
        content: '>';
        padding: 0 10px;
        color: var(--primary-color);
      }
    }
    @media (max-width: 767px) {
      justify-content: center;
    }
  }
`;
